/**
 * CartSee「站点 / 公司」维度 ID：与埋点脚本 URL 参数 `id=` 一致，运行时即 `c.id`（init 里会 Number 化）。
 * 用于按商户约定切换上报策略；具体店铺名以 CartSee 后台配置为准，此处仅说明分支用途，便于排查。
 */

/** 主 Shopify carttrack：`ajax.post` 的 `data.data` 为 JSON 字符串时，Cart/Add 优先 sendBeacon */
export const COMPANY_ID_SHOPIFY_SEND_BEACON_STRING_CART_ADD = 618;

/** 线下弹窗场景：加购上报的 pathName 追加 `cartsee_from=offline`（依赖 session `_cartsee_offline`） */
export const COMPANY_IDS_OFFLINE_CARTSEE_FROM_PATH = Object.freeze([173, 30]);

/** carttrack-common / carttrack-simple：所有 ajax.post 尝试 Blob + sendBeacon（规避部分环境对上报体的限制） */
export const COMPANY_IDS_SEND_BEACON_BLOB_AJAX_POST = Object.freeze([1561, 1565]);

/** Shopline：Cart/Add 且 body 为字符串时，Blob + sendBeacon */
export const COMPANY_IDS_SHOPLINE_SEND_BEACON_BLOB_CART_ADD = Object.freeze([1320]);

/** carttrack-yueqi 默认上报体中的 companyId */
export const COMPANY_ID_YUEQI = 561;

/** 主 Shopify：该站点在窗口期内节流重复请求 /cart.js */
export const COMPANY_ID_CART_JS_FETCH_THROTTLE = 3124;

/** HeyProm 相关商户，与自建站 checkout899、GA 采集等逻辑共用 */
export const COMPANY_IDS_HEYPROM = Object.freeze([2183, 2362, 2363, 2364, 2365, 2366]);

/** 自建站结账：使用新模板表单采集（collectionForm，对应 basic_* / shipping-* 等字段） */
export const COMPANY_IDS_CHECKOUT_COLLECTION_FORM_NEW = Object.freeze([
  1299, 1334, 1527, 1536, 1545, 1546, 1997, 2016, 2107, 2109, 2110, 2306, 2457, 2458
]);

const COMPANY_IDS_COMMON_CHECKOUT899_BASE = [
  899, 1182, 1299, 1334, 1527, 1536, 1545, 1546, 1804, 1881, 1882, 1883, 1997, 2016, 2107, 2109, 2110, 2306,
  2457, 2458
];

/** 自建站：启用 checkout899（结账邮箱 blur 等）的 companyId 全集 = 基础列表 + HEYPROM */
export const COMPANY_IDS_COMMON_CHECKOUT899_ALL = Object.freeze([
  ...COMPANY_IDS_COMMON_CHECKOUT899_BASE,
  ...COMPANY_IDS_HEYPROM
]);

/** checkout899 子分支：存在「新增地址」按钮，需点击后再挂监听 */
export const COMPANY_IDS_CHECKOUT899_ADD_ADDRESS_BRANCH = Object.freeze([1334, 1527, 1997]);

/** checkout899 子分支：延迟初始化（DOM 渲染时序） */
export const COMPANY_IDS_CHECKOUT899_DELAYED_INIT = Object.freeze([
  1299, 1536, 1545, 1546, 2016, 2107, 2109, 2110, 2306, 2457, 2458
]);

/** 抓取 GA client_id 并写入后续 Site/Visit（不再单独报 Site/GATrack；checkout899 子集 + HEYPROM） */
export const COMPANY_IDS_COMMON_GET_GA = Object.freeze([899, 1182, 1804, 1881, 1882, 1883, ...COMPANY_IDS_HEYPROM]);

/** Shoplazza 多市场：购物车 API 需带国别路径前缀 */
export const SHOPLAZZA_CART_COUNTRY_PREFIX_BY_COMPANY_ID = Object.freeze({
  1930: 'us',
  1935: 'sg'
});
